import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbEscolaridade extends AppService {
  abstract getAllEscolaridades(): Observable<any>;

}